export function existsCountry(data, sportId, countryId) {
    return data?.sportById?.[sportId]?.categoryById?.[countryId];
}
